import { AnswerOptionsList } from '../AnswerOptionsList/AnswerOptionsList';

import type { AnswerOptionConfig } from '../AnswerOptionsList/types';

export interface CheckboxQuestionAnswerProps {
    options: AnswerOptionConfig[];
    selectedValues?: string[];
    onAnswerChange: (values: string[]) => void;
    maxSelection?: number;
    disabled?: boolean;
    dataTestId?: string;
    ariaLabel?: string;
    ariaDescribedBy?: string;
}

export const CheckboxQuestionAnswer = ({
    options,
    selectedValues = [],
    onAnswerChange,
    maxSelection,
    disabled = false,
    dataTestId,
    ariaLabel,
    ariaDescribedBy,
}: CheckboxQuestionAnswerProps) => {
    const handleChange = (values: string[]) => {
        if (!disabled) {
            onAnswerChange(values);
        }
    };

    return (
        <div
            className={'w-full'}
            role={'group'}
            aria-label={ariaLabel}
            aria-describedby={ariaDescribedBy}
            aria-disabled={disabled}
            data-testid={dataTestId}
        >
            <AnswerOptionsList
                options={options}
                selectedValues={selectedValues}
                onChange={handleChange}
                multiple={true}
                maxSelection={maxSelection}
                className={disabled ? 'pointer-events-none opacity-50' : ''}
                dataTestId={dataTestId ? `${dataTestId}-options-list` : undefined}
            />
        </div>
    );
};

export default CheckboxQuestionAnswer;
